import React from 'react';
import './Stats.css';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const statsData = [
    { value: '10+', label: 'Лет в разработке' },
    { value: '12+', label: 'Реализованных проектов' },
    { value: '500+', label: 'Активных пользователей продукта' },
    { value: '99.9%', label: 'Аптайм сервисов' }
];

function StatItem({ stat }) {
    const statRef = useScrollAnimation();

    return (
        <div className="stat-item" ref={statRef}>
            <h4>{stat.value}</h4>
            <p>{stat.label}</p>
        </div>
    );
}

function Stats() {
    return (
        <section className="stats-section">
            <div className="section-inner" style={{textAlign: 'center', marginBottom: '3rem'}}>
                <span className="section-label">Результаты</span>
                <h2 className="section-title">Цифры говорят<br />за нас</h2>
            </div>
            <div className="stats-grid">
                {statsData.map((stat, index) => (
                    <StatItem stat={stat} key={index} />
                ))}
            </div>
        </section>
    );
}

export default Stats;